/**
 * Created by 小猪猪lover on 2019/1/10.
 */
(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('outgoingAndWarehousing2', {
                parent: 'module',
                url: '/outgoingAndWarehousing2',
                params:{page: null},
                data: {
                    authorities: ['ROLE_MATERIAL_OUTIN']
                },
                views: {
                    'content': {
                        templateUrl: 'app/accessories/outgoingAndWarehousing/outgoingAndWarehousing.html',
                        controller: 'OutgoingWarehousingTwoController',
                        controllerAs: 'vm'
                    }
                }
            })
    }
})();
